var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isFetchProduct)?_c('div',[_c('ProductForm',{attrs:{"productDetail":_vm.productDetail,"update":true},on:{"saveDetail":_vm.updateProduct}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }